import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MerchantDailySummaryComponent } from './merchant-daily-summary/merchant-daily-summary.component';
import { ReportsListComponent } from './reports-list.component';
import {SettlementsComponent} from './settlements/settlements.component';
import {TransactionsComponent} from './transactions/transactions.component';

const routes: Routes = [
    {
        path: 'reports',
        data: {
            title: 'Reports'
        },
        children: [
            { path: '', component: ReportsListComponent },
            {
                path: 'transaction-report',
                data: {
                    title: 'Merchant Transaction Report'
                },
                component: TransactionsComponent
            },
            {
                path: 'settlement-report',
                data: {
                    title: 'Settlement Report'
                },
                component: SettlementsComponent
            },
            {
                path: 'daily-summary-report',
                data: {
                    title: 'Daily Summary Report'
                },
                component: MerchantDailySummaryComponent
            }
        ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ReportsRoutingModule { }
